import * as React from 'react';

export const pkFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_380)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#003F15'
            />
            <mask
                id='mask0_1_380'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_380)'>
                <path
                    d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                    fill='#003F15'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M21.2987 7.96533C21.2107 8.76 20.96 9.33333 20.6667 9.33333C20.3733 9.33333 20.1227 8.76 20.0347 7.96533C19.24 7.87733 18.6667 7.62667 18.6667 7.33333C18.6667 7.04 19.24 6.78933 20.0347 6.70133C20.1227 5.90667 20.3733 5.33333 20.6667 5.33333C20.96 5.33333 21.2107 5.90667 21.2987 6.70133C22.0933 6.78933 22.6667 7.04 22.6667 7.33333C22.6667 7.62667 22.0933 7.87733 21.2987 7.96533ZM0 0H8V20H0V0Z'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M23.96 9.29067C23.9867 9.524 24 9.76 24 10C24 13.3133 21.3133 16 18 16C14.6867 16 12 13.3133 12 10C12 6.68667 14.6867 4 18 4C18.24 4 18.476 4.01333 18.7093 4.04C16.4267 4.34667 14.6667 6.30267 14.6667 8.66667C14.6667 11.244 16.756 13.3333 19.3333 13.3333C21.6987 13.3333 23.6533 11.5733 23.96 9.29067Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_380'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
